<div class="main">
  <div class="nav-bar">
    <div class="nav-bar-title">پیشنهاد برای شما</div>
  </div>
  <div class="back-holder" (click)="closeSuggest()">
    <img src="assets/general/back-blue.svg" />
  </div>
  <div class="suggested-users-container">
    <div
      class="suggested-user-box"
      *ngFor="let suggestedUser of input; let last = last"
      [ngStyle]="{ 'margin-bottom': last ? '16px' : '0' }"
    >
      <img
        *ngIf="suggestedUser.avatarPath !== ''"
        src="{{ suggestedUser.avatarPath }}"
        onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
        (click)="openProfile(suggestedUser.userName)"
      />
      <img
        *ngIf="suggestedUser.avatarPath === ''"
        src="assets/blog/avatar.svg"
        (click)="openProfile(suggestedUser.userName)"
      />
      <div
        class="suggested-user-username"
        (click)="openProfile(suggestedUser.userName)"
      >
        {{ suggestedUser.userName }}
      </div>
      <div
        *ngIf="
          !blogShared.followedSuggestedUsernames.includes(
            suggestedUser.userName
          ) &&
          !blogShared.pendingSuggestedUsernames.includes(suggestedUser.userName)
        "
        class="suggested-user-follow"
        (click)="follow(suggestedUser)"
      >
        دنبال کردن
      </div>
      <div
        *ngIf="
          blogShared.pendingSuggestedUsernames.includes(suggestedUser.userName)
        "
        class="suggested-user-follow-pending"
        (click)="unFollow(suggestedUser)"
      >
        در انتظار تایید
      </div>
      <div
        *ngIf="
          blogShared.followedSuggestedUsernames.includes(suggestedUser.userName)
        "
        class="suggested-user-following"
        (click)="unFollow(suggestedUser)"
      >
        دنبال شده
      </div>
    </div>
  </div>
</div>
